import * as yup from "yup";
import i18next from "config/i18next";
import { VALIDATION_REGEX } from "utils/constants";
import { FilterContainerValidationSchemaTypes } from "./types";
export const validationSchemaCL: yup.SchemaOf<FilterContainerValidationSchemaTypes> =
  yup.object({
    name: yup
      .string()
      .matches(
        VALIDATION_REGEX.expName,
        i18next.t("validations:numbersOrSpecialCharacters")
      ),
    identificationNumber: yup
      .string()
      .min(9, i18next.t("filterPickers:enterValidFormat"))
      .matches(
        VALIDATION_REGEX.regRUN,
        i18next.t("validations:enterValidFormat")
      ),
    email: yup
      .string()
      .matches(
        VALIDATION_REGEX.regEmail,
        i18next.t("validations:invalidEmailFormat")
      ),
  });
